import { TaskAlt } from '@mui/icons-material';
import React from 'react';
import ButtonDesigned from '../Buttons/ButtonDesigned';

interface Props {
  close: () => void;
}

export const FileUploadedSuccess: React.FC<Props> = ({ close }) => {
  return (
    <div className="fixed flex items-center justify-center top-0 left-0 w-100 h-100 z-50 bg-gray-700 bg-opacity-50">
      <div className="flex flex-col flex-1 bg-white shadow-custom p-4 items-center justify-center gap-4 max-w-96">
        <TaskAlt sx={{ fill: '#4ACB3E', width: '64px', height: '64px' }} />
        <div className="flex flex-col gap-0 items-center">
          <p className="font-semibold">File Submitted</p>
          <p className="text-gray-700">Your file was submitted successfully.</p>
        </div>
        <ButtonDesigned style="primary" onButtonClick={close} className="px-8 py-2">
          OK
        </ButtonDesigned>
      </div>
    </div>
  );
};
